import { render, staticRenderFns } from "./zhenLand.vue?vue&type=template&id=34567094&scoped=true"
import script from "./zhenLand.vue?vue&type=script&lang=js"
export * from "./zhenLand.vue?vue&type=script&lang=js"
import style0 from "./zhenLand.vue?vue&type=style&index=0&id=34567094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34567094",
  null
  
)

export default component.exports